import { useMemo } from "react";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api/lib/api";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import { useApacHotelsStyles } from "../../hooks";
import { ApacHotelsComponent } from "../../types";
import defaultStyles from "./styles.module.scss";

export type HotelTripadvisorRatingProps = PlatformComponentProps & {
  hotel: Lodging;
};

export const HotelTripadvisorRating = ({
  hotel,
  className,
}: HotelTripadvisorRatingProps) => {
  const COMPONENT_KEY = ApacHotelsComponent.HotelTripadvisorRating;
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const shortRate = useMemo(() => {
    const score = (hotel.lodging?.score * 5).toFixed(1);
    return score + "/5";
  }, [hotel.lodging?.score]);

  const scoreCount = useMemo(() => {
    const count = hotel.lodging?.tripAdvisorReviews?.reviewsCount ?? 0;
    return { count, formatted: count > 999 ? "999+" : String(count) };
  }, [hotel.lodging?.tripAdvisorReviews]);

  return scoreCount.count > 0 ? (
    <div className={clsx(block, className)}>
      <Icon iconName={IconNameEnum.tripadvisor} useCurrentColor={false} />
      <span className={cn("score")}>{shortRate}</span>({scoreCount.formatted})
    </div>
  ) : null;
};
